import React, { useCallback, useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { AcademyAdminActivity } from '../components/academy/admin/AcademyAdminActivity';
import { AcademyAdminCourseTable } from '../components/academy/admin/AcademyAdminCourseTable';
import { AcademyAdminKpis } from '../components/academy/admin/AcademyAdminKpis';
import { PageHeader } from '../components/ui/PageHeader';
import { getAcademyAdminDashboard } from '../services/academyAdminReadService';

const { FiRefreshCw } = FiIcons;

export function AcademyAdminDashboard() {
  const [dashboard, setDashboard] = useState(null);
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState('');

  const loadDashboard = useCallback(async () => {
    setStatus('loading');
    setError('');

    try {
      const result = await getAcademyAdminDashboard();
      setDashboard(result);
      setStatus('ready');
    } catch (failure) {
      setError(failure?.message || 'Academy-oversikten kunne ikke lastes.');
      setStatus('error');
    }
  }, []);

  useEffect(() => {
    void loadDashboard();
  }, [loadDashboard]);

  return (
    <div className="space-y-8">
      <PageHeader
        title="Academy Admin"
        intro="Administrativ oversikt over kurs, deltakere, fullføringer og kursbevis."
        breadcrumb="HMS-innsikt / Academy"
        actions={
          <button
            type="button"
            onClick={loadDashboard}
            disabled={status === 'loading'}
            className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 transition hover:border-blue-200 hover:text-blue-700 disabled:cursor-wait disabled:opacity-60"
          >
            <SafeIcon
              icon={FiRefreshCw}
              className={status === 'loading' ? 'animate-spin' : ''}
            />
            Oppdater
          </button>
        }
      />

      {status === 'loading' && (
        <p role="status" className="rounded-xl border border-slate-200 bg-white p-5 text-sm text-slate-600">
          Laster Academy-data …
        </p>
      )}

      {status === 'error' && (
        <div role="alert" className="rounded-xl border border-rose-200 bg-rose-50 p-5">
          <h2 className="font-semibold text-rose-800">Academy-data kunne ikke lastes</h2>
          <p className="mt-2 text-sm text-rose-700">{error}</p>
        </div>
      )}

      {status === 'ready' && dashboard && (
        <>
          <AcademyAdminKpis metrics={dashboard.metrics} />
          <AcademyAdminCourseTable courses={dashboard.courses} />
          <AcademyAdminActivity activity={dashboard.activity} />
        </>
      )}
    </div>
  );
}

export default AcademyAdminDashboard;